// extracted by mini-css-extract-plugin
export default {"reportingHomePageHeader":"ReportingHomePageHeader_reportingHomePageHeader__K21qD"};